import { type InferOutput, object, string } from "valibot";

export const LoginSchema = object({
  username: string(),
  password: string(),
});

export type LoginData = InferOutput<typeof LoginSchema>;
